/**
 *
 *  Copyright 2016 Netflix, Inc.
 *
 *     Licensed under the Apache License, Version 2.0 (the "License");
 *     you may not use this file except in compliance with the License.
 *     You may obtain a copy of the License at
 *
 *         http://www.apache.org/licenses/LICENSE-2.0
 *
 *     Unless required by applicable law or agreed to in writing, software
 *     distributed under the License is distributed on an "AS IS" BASIS,
 *     WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *     See the License for the specific language governing permissions and
 *     limitations under the License.
 *
 */
import Node from '../base/node';
import FocusedNodeView from '../focused/focusedNodeView';

class GlobalNode extends Node {
  constructor (node, entryNode) {
    node.size = node.size || 120;
    super(node, 'global', entryNode);
    this.refreshLoaded();
  }

  isInteractive () {
    return this.nodes && this.nodes.length > 0;
  }

  isDraggable () {
    return true;
  }

  refreshLoaded () {
    this.loaded = this.isEntryNode() || (this.nodes && this.nodes.length > 0);
  }

  invalidateIncomingVolume () {
    super.invalidateIncomingVolume();
    this.refreshLoaded();
  }

  invalidateOutgoingVolume () {
    super.invalidateOutgoingVolume();
    this.refreshLoaded();
  }

  render () {
    this.view = new FocusedNodeView(this);
  }
}

export default GlobalNode;
